export default __webpack_public_path__ + "static/media/Snd_9_Starts.9b6edada.mp3";